module.exports = __webpack_public_path__ + "static/media/cabinet_milestones_btn.beed9c08.svg";